import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useMemo, useState } from 'react'
import { Fire } from 'react-bootstrap-icons'
import { SharedCampaignContext } from '../../../../../../../contexts/Advertiser/SharedCampaignContext'
import { currencyFormat } from '../../../../../../../utils/Helper'
import DropdownButton from '../../../../../../FormComponents/DropdownButton'
import NonMediaActions from './NonMediaActions'

export default observer(function NonMediaScenarioActionGroup({ actionGroup, campaignScenario }) {
  const { campaign } = useContext(SharedCampaignContext)
  const [dropdownOpen, setDropdownOpen] = useState(true)

  const actions = useMemo(() => campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id === actionGroup.id), [campaignScenario.actions, campaignScenario.actions.length])

  const advertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))

  return (
    <Fragment>
      <div className={`grid grid-cols-8 ${dropdownOpen && 'border-b-2 border-border-primary dark:border-rb-dark-mode-lighter'}`}>
        <div className="flex items-center justify-between col-span-5 p-2 border-r-2 border-border-primary dark:border-rb-dark-mode-lighter col-span-6">
          <div className="flex items-center">
            <Fire className="text-white bg-gray-950" style={{ padding: 2 }} />
            <p className="ml-2 font-bold dark:text-white">Non-media</p>
          </div>
          <div className="flex items-center">
            <DropdownButton dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} className="dark:text-white" />
          </div>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2 col-span-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Price</p>
          <p className="font-bold dark:text-white">{currencyFormat(advertiserPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
      </div>
      { dropdownOpen && <NonMediaActions actions={actions} campaignScenario={campaignScenario} actionGroup={actionGroup} />}
    </Fragment>
  )
})